var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseButton',{attrs:{"name":_vm.text,"bem-modifiers":['horizontally-centered']},nativeOn:{"click":function($event){return _vm.logout($event)}}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }